import { useMutation } from '@tanstack/react-query'
import { type GeneratePdfRequest, pdfApi } from '@/services/api/pdf'

/**
 * Posts to /v1/pdf/generate and triggers a browser download of the returned
 * PDF blob. The backend also persists the file to object storage; we only deal
 * with the inline response here.
 */
export function useGeneratePdf() {
  return useMutation({
    mutationFn: async (params: GeneratePdfRequest) => {
      const blob = await pdfApi.generate(params)
      const filename = `${params.template}_${params.subjectRef}.pdf`
      downloadBlob(blob, filename)
      return { filename }
    },
  })
}

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
